module.exports = __webpack_public_path__ + "img/factor_a_blue.68f5bc66.svg";